import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type MinusProps = {
    className?: string;
};

const Minus: FunctionComponent<MinusProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'minus'}
            viewBox="0 -120 250 250"
        >
            <rect width="250" height="15" rx="10" />
        </svg>
    );
};
export default Minus;
